import React from "react";

const DateComponent = props => {
  console.log(props.data.date);
  return <>{props.data.date}</>;
};

export default DateComponent;
